module.exports = __webpack_public_path__ + "img/Home.acab6962.svg";